import { motion } from "framer-motion";
import { useStore } from "../context/StoreContext";

export const Ritual = () => {
  const { t } = useStore();
  return (
    <section id="ritual" className="py-24 lg:py-36 px-6 lg:px-14 xl:px-24 max-w-[1500px] mx-auto" data-testid="ritual-section">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16"
      >
        <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#4A624E] mb-4 flex items-center gap-3">
          <span className="w-8 h-px bg-[#4A624E]" />
          {t.ritual.overline}
        </p>
        <h2 className="font-serif text-3xl lg:text-4xl tracking-tight text-stone-900 max-w-lg">{t.ritual.title}</h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {t.ritual.steps.map((s, i) => (
          <motion.div
            key={s.t}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12 }}
            className="border-t border-stone-300 pt-6 group hover:border-[#C85A32] transition-colors duration-500"
            data-testid={`ritual-step-${i + 1}`}
          >
            <span className="font-mono text-[11px] tracking-[0.3em] text-stone-400">0{i + 1}</span>
            <h3 className="mt-4 font-serif text-2xl text-stone-900 italic group-hover:text-[#C85A32] transition-colors duration-500">{s.t}</h3>
            <p className="mt-3 text-sm text-stone-600 leading-relaxed">{s.d}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
